import { type JSX } from 'react';
import { useIntl } from 'react-intl';

import { WrapTextIcon, WrapTextOffIcon } from '@dynatrace/strato-icons';

import { Button } from '../../../../buttons/button/Button.js';
import { Tooltip } from '../../../../overlays/tooltip/Tooltip.js';
import { useDataTable } from '../../contexts/DataTableContext.js';
import { dataTableMessages } from '../../messages.js';

/**
 * Provides the toolbar button that allows toggling global line wrap.
 * @internal
 */
export function DataTableGlobalLineWrapToolbarAction(): JSX.Element {
  const table = useDataTable();
  const intl = useIntl();

  const lineWrapState = table.atoms.columnLineWrap?.get();
  const Icon = lineWrapState === true ? <WrapTextOffIcon /> : <WrapTextIcon />;
  const lineWrapLabel =
    lineWrapState === true
      ? intl.formatMessage(dataTableMessages.disableLineWrapLabel)
      : intl.formatMessage(dataTableMessages.enableLineWrapLabel);

  const lineWrapDtProperty = `state:${
    lineWrapState === true ? 'unwrap' : 'wrap'
  }`;

  return (
    <Tooltip text={lineWrapLabel}>
      <Button
        aria-label={lineWrapLabel}
        data-dt-children-name="ToolbarLineWrap"
        data-dt-properties={lineWrapDtProperty}
        onClick={() =>
          table.setColumnLineWrap((oldLineWrap) => {
            if (oldLineWrap === true) {
              return {};
            }
            return true;
          })
        }
      >
        <Button.Prefix>{Icon}</Button.Prefix>
      </Button>
    </Tooltip>
  );
}
